import React from 'react';
import { useQuery } from '@apollo/client';
import 'react-helmet';
import 'react-router-dom';
import 'quanta-ui';
import '@fortawesome/free-solid-svg-icons';
import '@fortawesome/react-fontawesome';
import './queries-3df8abcc.js';
import { E as Error } from './error-ee5266a9.js';
import { L as Loading } from './loading-c16d3bd3.js';
import './queries-a3e6305b.js';

function Digilink(_ref) {
  var REACTIVE_VAR_QUERY = _ref.REACTIVE_VAR_QUERY,
      reactiveVarName = _ref.reactiveVarName;

  var _useQuery = useQuery(REACTIVE_VAR_QUERY),
      loadingReactivear = _useQuery.loading,
      errorReactiveVar = _useQuery.error,
      dataReactiveVar = _useQuery.data;

  if (loadingReactivear) {
    return /*#__PURE__*/React.createElement("div", {
      className: "min-h-screen"
    }, /*#__PURE__*/React.createElement(Loading, null));
  }

  if (errorReactiveVar) {
    return /*#__PURE__*/React.createElement(Error, {
      errorReactiveVar: errorReactiveVar
    });
  }

  if (dataReactiveVar) {
    dataReactiveVar["".concat(reactiveVarName)];
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "mt-8 text-primary"
  });
}

export { Digilink as D };
